import BaseViewModel, { BaseViewModelParams } from "./BaseViewModel";

class IntegerControlViewModel extends BaseViewModel {
	
	Mask: string = '^[0-9]+$';
	MaxValue: number;
	MinValue: number;

	constructor ( params: BaseViewModelParams ) {
		super( params );
		this.MaxValue = +params.elementDescriptor.MaxValue;
		this.MinValue = +params.elementDescriptor.MinValue;
	};

	runValidation = () => {
		const regExpr = new RegExp(this.Mask, 'ig');
		return regExpr.test( this.Value );
	};

};

export default IntegerControlViewModel;
